import type {Components, Theme} from '@mui/material/styles';

export const dialogOverrides: Components<Theme>['MuiDialog'] = {
    defaultProps: {
        PaperProps: {
            elevation: 0,
        },
    },
};

export const dialogContentTextOverrides: Components<Theme>['MuiDialogContentText'] = {
    styleOverrides: {
        root: ({theme}) => ({
            color: theme.palette.text.primary,
        }),
    },
};
